import { ThemeType } from '@/creditflowresearch/domain/vo/ArticlesAndStats/Articles/themeTypes';

export const mapTypeToUrl = {
  [ThemeType.commentary]: '/commentary',
  [ThemeType.dealFlow]: '/deal-flow',
};
